import { useSuspenseQuery } from '@tanstack/react-query'

import { getPartnerDetailQueryOptions } from '../query-options'

export const usePartner = (param: { tenantKey: string; partnerId: number }) => {
  const { data } = useSuspenseQuery(getPartnerDetailQueryOptions(param))
  return data
}
